import { render, staticRenderFns } from "./chooseRecipe.vue?vue&type=template&id=e43f181a&scoped=true"
import script from "./chooseRecipe.vue?vue&type=script&lang=js"
export * from "./chooseRecipe.vue?vue&type=script&lang=js"
import style0 from "./chooseRecipe.vue?vue&type=style&index=0&id=e43f181a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43f181a",
  null
  
)

export default component.exports